export enum AttachmentsTypes {
  GET_ATTACHMENTS = '@@attachments/GET_ATTACHMENTS',
  GET_ATTACHMENTS_SUCCESS = '@@attachments/GET_ATTACHMENTS_SUCCESS',
  GET_ATTACHMENTS_FAIL = '@@attachments/GET_ATTACHMENTS_FAIL',

  GET_ONE_ATTACHMENT = '@@attachments/GET_ONE_ATTACHMENT',
  GET_ONE_ATTACHMENT_SUCCESS = '@@attachments/GET_ONE_ATTACHMENT_SUCCESS',
  GET_ONE_ATTACHMENT_FAIL = '@@attachments/GET_ONE_ATTACHMENT_FAIL',
}
